import { z } from 'zod';

const EnvSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_API_BASE_URL: z.string().url(),
});

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const missing = parsed.error.issues
    .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
    .join('\n');
  const msg = `❌ Web env validation failed. Refusing to boot.\n${missing}\n\nSee apps/web/.env.local.example for required keys.`;
  // Surface visibly during development; throwing aborts the bundle.
  console.error(msg);
  throw new Error(msg);
}

export const env = Object.freeze(parsed.data);
